.component {
  background: var(--color-body);
  border: 1px solid var(--color-body);
  border-radius: var(--border-radius-s);
  position: relative;
  transition: background 0.15s ease-in-out, border 0.15s ease-in-out;
  margin-bottom: var(--space-m);
  display: block;
  width: 100%;
  cursor: pointer;

  .addButton {
    position: absolute;
    top: 50%;
    right: var(--space-m);
    opacity: 0;
    transform: translateY(-50%) translateX(10px);
    transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
  }

  &:hover {
    background: none;
    border-color: var(--color-svp-grey);

    .addButton {
      opacity: 1;
      transform: translateY(-50%);
    }
  }

  &.isDisabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
